import React, {useEffect, useState} from 'react';
import {Table, Input, Button, List, message} from 'antd';
import history from "../../../libs/history";
import {observer} from 'mobx-react';
import {toJS} from "mobx";
import http from "libs/http"

import store from "./store";
import addressStore from "../info/address/store"
import invoiceStore from "../info/invoice/store"
import projectStore from '../project/store'

import styles from './layout.module.less'

// the hook
import { useTranslation } from 'react-i18next';

const {TextArea} = Input;

export default observer(function () {
  const {t, i18n} = useTranslation()
  const [loading, setLoading] = useState(false)
  const {handleRecord, handleId, invoiceId, poNum} = store
  const columns = [
    {
      title: '',
      dataIndex: 'sell',
      className: 'pl0',
      width: 35,
      fixed: true,
      render: val => <div className={[styles.badge,i18n.language==='en'?styles.autoWidth:''].join(" ")}>{val ? t('购') : t('租')}</div>,
    },
    {
      title: t('品牌'),
      dataIndex: 'brand',
      align: 'center',
      fixed: true,
      width: 90,
    },
    {
      title: t('产品品名'),
      dataIndex: 'name',
      align: 'center',
      fixed: true,
      width: 150,
    },
    {
      title: t('货号'),
      dataIndex: 'factory_code',
      align: 'center',
      fixed: true,
      width: 100,
    },
    {
      title: t('规格'),
      dataIndex: 'formats',
      align: 'center',
      fixed: true,
      width: 50,
    },
    {
      title: t('单价'),
      dataIndex: 'price',
      align: 'center',
      fixed: true,
      render: (val, record, index) => <div>{val ? val + (record.type * 1 === 2 ? '元/月' : '元') : '-'}</div>,
    },
    {
      title: t('租期'),
      dataIndex: 'duration',
      align: 'center',
      fixed: true,
      render: val => <div>{val ? val + '月' : '-'}</div>,
    },
    {
      title: t('数量'),
      dataIndex: 'number',
      align: 'center',
      fixed: true,
    },
    {
      title: t('合计'),
      dataIndex: 'total_price',
      align: 'center',
      fixed: true,
      render: val => <div>{val}元</div>,
    },
    {
      title: t('项目编号'),
      dataIndex: 'extra_sn',
      width: 90,
      align: 'center',
      fixed: true,
      render:  (val, record, index) => {
        let project=projectStore.records.filter(v=>v.id===val*1)
        let txt='-'
        if(project.length){
          txt=project[0]['sn']
        }
        return <div>{txt}</div>
      },
    },
    {
      title: t('预计到货'),
      dataIndex: 'period',
      width: 70,
      align: 'center',
      fixed: true,
      render: val => <div>{val ? val : '-'}</div>,
    },
  ]

  if (handleId === '') {
    message.warn(t('请选择报价单')+'！')
    history.push('/user/quote')
    return
  }

  useEffect(() => {
    invoiceStore.invoices.length > 0 ? filterInvoice() : invoiceStore.fetchRecodes().then(filterInvoice)
    projectStore.fetchRecords()

  }, [])

  const filterInvoice = () => {
    const defInvoice = invoiceStore.invoices.filter(v => v.is_default)
    if (defInvoice.length) {
      store.invoiceId = defInvoice[0].id
    } else if (invoiceStore.invoices.length) {
      store.invoiceId = invoiceStore.invoices[0].id
    }
  }

  const handleSubmit = () => {
    if (!poNum) {
      message.warn(t('请输入')+' '+t('PO号')+'！')
      return
    }

    setLoading(true)
    store.checkOrder({quote_id: handleId, invoice_id: invoiceId, po_sn: poNum}).then(() => {
      history.push('/user/quote/submit')
    }).finally(() => setLoading(false))
  }

  return (
    <React.Fragment>
      <div className={styles.cart}>

        <div className={styles.listTitle}>
          <div className={['steps', styles.steps].join(" ")} data-class={'prev, cur'}>
            <div className="step prev">{t('我的报价单')}</div>
            <div className="step cur">{t('填写并核对订单信息')}</div>
            <div className="step ">{t('提交订单')}</div>
          </div>
        </div>

        <div className="mainBox-">

          <div className="paramSelect">
            <div className="h1"><em>{t('请选择发票信息，核对订单信息')}</em></div>
            <div className="h2">
              <span>{t('发票信息')}</span>
            </div>

            <div className="paramSelect">

              <div className="paramsList">

                <List
                  style={{margin: '0 auto', width: '100%'}}
                  header=''
                  footer=''
                  dataSource={toJS(invoiceStore.invoices)}
                  split={false}
                  pagination={false}
                  grid={{column: 3, gutter: 23}}
                  loading={invoiceStore.isFetching}
                  renderItem={item => (
                    <List.Item>

                      <div className={['item', item.id === invoiceId ? 'cur' : ''].join(" ")}
                           style={{minHeight: '120px'}}
                           onClick={() => store.invoiceId = item.id}>
                        <div className="param">
                          <div className="label">{t('发票抬头')}：</div>
                          <div className="text">{item.title}</div>
                        </div>
                        <div className="param">
                          <div className="label">{t('纳税登记号')}：</div>
                          <div className="text">{item.tax_sn}</div>
                        </div>
                      </div>


                    </List.Item>
                  )}/>

              </div>
            </div>

          </div>


          <div className={styles.innerTitle} style={{paddingLeft: 0}}>
            <span className={styles.title}>{t('商品确认')}</span>
            <span className={styles.des}>{t('订购后在货期内发货，如果因特殊原因货期状态发生变化，客服人员会第一时间与您确认货期')}</span>
          </div>
          <Table className={styles.table}
                 pagination={false}
                 rowKey={item => item.id + '-' + item.type}
                 dataSource={handleRecord.goods}
                 columns={columns}/>


          <div className={['flex', styles.checkFt].join(" ")}>
            <div className={styles.msg}>

              <p>{t('PO号')}</p>
              <Input autoComplete="off" placeholder={t('请输入')+' '+t('PO号')+'！'} onChange={e => store.poNum = e.target.value}/>

              {/*<p>备注</p>*/}
              {/*<TextArea*/}
              {/*  onChange={v => store.remark = v}*/}
              {/*  placeholder="不超过200字，非必填"*/}
              {/*  showCount={true}*/}
              {/*  maxLength={200}*/}
              {/*  autoSize={{minRows: 3, maxRows: 5}}*/}
              {/*/>*/}
            </div>
            <div className={styles.btnGroup}>
              <div style={{textAlign: 'right', margin: '40px 5px', fontSize: '20px'}}>{t('订单总金额 共计')}：<span
                style={{color: '#cc0000'}}>￥{handleRecord['total_price']}</span></div>


              <Button type="primary" size="large" onClick={() => history.go(-1)} ghost>{t('返回修改')}</Button>
              <Button type="primary" size="large" onClick={() => handleSubmit()}>{t('确认提交')}</Button>
            </div>
          </div>
        </div>


      </div>

    </React.Fragment>
  )

})
